import { Component } from '@angular/core';
import { AppUpdatesService } from './service/app-updates.service';

@Component({
  selector: 'app-update-footer',
  template: `
    <div class="footer">
      <span>{{ 'updatesAvailable' | translate }}</span>
      <div class="button-container">
        <ipo-button [type]="'inverted-red'" (clicked)="onClose()">
          {{ 'ignore' | translate }}
        </ipo-button>
        <ipo-button [type]="'inverted'" (clicked)="onReload()">
          {{ 'reload' | translate }}
        </ipo-button>
      </div>
    </div>
  `,
  styleUrls: ['./update-footer.component.scss'],
  standalone: false,
})
export class UpdateFooterComponent {
  constructor(private updatesService: AppUpdatesService) {}

  onClose() {
    this.updatesService.rejectUpdate();
  }

  onReload() {
    this.updatesService.activateUpdate();
  }
}
